import {combineReducers} from '@reduxjs/toolkit'

import assembly     from '../pcb-assembly/data/AssemblySlice'
import parts        from '../pcb-parts/data/PartsSlice'
import fabrication  from '../pcb-fabrication/data/FabricationSlice'
import project      from './data/ProjectSlice'

const rootReducer = combineReducers({
  project,
  assembly,
  fabrication,
  parts,
});

export default rootReducer
